var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { ref, computed } from "vue";
import "../../../../_virtual/google-sheets.js";
import "../../../../_virtual/brand-eci.js";
import "../../../../_virtual/brand-ecigames.js";
import "../../../../_virtual/brand-unreal.js";
import "../../../../_virtual/filter-dot.js";
import "../../../../_virtual/move.js";
import "../../../../_virtual/save.js";
import "../../../../_virtual/sign-minus-bold.js";
import "../../../../_virtual/stars.js";
import "../../../../_virtual/tb.js";
import "../../../../_virtual/tm.js";
import "../../../../_virtual/abc.js";
import "../../../../_virtual/adjustments.js";
import "../../../../_virtual/alert-circle.js";
import "../../../../_virtual/alert-circle-filled.js";
import "../../../../_virtual/alert-triangle.js";
import "../../../../_virtual/alert-triangle-filled.js";
import "../../../../_virtual/arrow-autofit-height.js";
import "../../../../_virtual/arrow-back.js";
import "../../../../_virtual/arrow-back-up.js";
import "../../../../_virtual/arrow-bar-left.js";
import "../../../../_virtual/arrow-bar-right.js";
import "../../../../_virtual/arrow-big-right-lines-filled.js";
import "../../../../_virtual/arrow-big-up-lines-filled.js";
import "../../../../_virtual/arrow-forward-up.js";
import "../../../../_virtual/arrow-left.js";
import "../../../../_virtual/arrow-narrow-right.js";
import "../../../../_virtual/arrow-right.js";
import "../../../../_virtual/arrow-up-right.js";
import "../../../../_virtual/arrows-diagonal.js";
import "../../../../_virtual/arrows-diagonal-minimize-2.js";
import "../../../../_virtual/arrows-horizontal.js";
import "../../../../_virtual/arrows-up-down.js";
import "../../../../_virtual/arrows-vertical.js";
import "../../../../_virtual/at.js";
import "../../../../_virtual/automatic-gearbox.js";
import "../../../../_virtual/ban.js";
import "../../../../_virtual/bell.js";
import "../../../../_virtual/bold.js";
import "../../../../_virtual/bolt.js";
import "../../../../_virtual/book.js";
import "../../../../_virtual/brand-apple-filled.js";
import "../../../../_virtual/brand-git.js";
import "../../../../_virtual/brand-google-filled.js";
import "../../../../_virtual/brand-unity.js";
import "../../../../_virtual/brand-x.js";
import "../../../../_virtual/browser.js";
import "../../../../_virtual/bucket-droplet.js";
import "../../../../_virtual/building-store.js";
import "../../../../_virtual/bulb.js";
import "../../../../_virtual/calculator.js";
import "../../../../_virtual/calendar.js";
import "../../../../_virtual/calendar-bolt.js";
import "../../../../_virtual/chart-bar.js";
import "../../../../_virtual/check.js";
import "../../../../_virtual/chevron-down.js";
import "../../../../_virtual/chevron-left.js";
import "../../../../_virtual/chevron-right.js";
import "../../../../_virtual/chevron-up.js";
import "../../../../_virtual/chevrons-down.js";
import "../../../../_virtual/chevrons-left.js";
import "../../../../_virtual/chevrons-right.js";
import "../../../../_virtual/chevrons-up.js";
import "../../../../_virtual/circle.js";
import "../../../../_virtual/circle-check-filled.js";
import "../../../../_virtual/circle-dashed.js";
import "../../../../_virtual/circle-filled.js";
import "../../../../_virtual/circle-key.js";
import "../../../../_virtual/circle-letter-t.js";
import "../../../../_virtual/circle-plus.js";
import "../../../../_virtual/circle-x-filled.js";
import "../../../../_virtual/circles-relation.js";
import "../../../../_virtual/clock.js";
import "../../../../_virtual/clock-hour-4.js";
import "../../../../_virtual/cloud.js";
import "../../../../_virtual/cloud-upload.js";
import "../../../../_virtual/code.js";
import "../../../../_virtual/columns.js";
import "../../../../_virtual/columns-3.js";
import "../../../../_virtual/copy.js";
import "../../../../_virtual/credit-card.js";
import "../../../../_virtual/credit-card-pay.js";
import "../../../../_virtual/database.js";
import "../../../../_virtual/database-cog.js";
import "../../../../_virtual/device-mobile.js";
import "../../../../_virtual/dots.js";
import "../../../../_virtual/download.js";
import "../../../../_virtual/edit.js";
import "../../../../_virtual/external-link.js";
import "../../../../_virtual/eye.js";
import "../../../../_virtual/eye-off.js";
import IconFile from "../../../../_virtual/file.js";
import "../../../../_virtual/file-check.js";
import "../../../../_virtual/file-code.js";
import "../../../../_virtual/file-description.js";
import "../../../../_virtual/file-dollar.js";
import "../../../../_virtual/file-excel.js";
import "../../../../_virtual/file-pencil.js";
import "../../../../_virtual/file-search.js";
import "../../../../_virtual/file-spreadsheet.js";
import "../../../../_virtual/file-text.js";
import "../../../../_virtual/file-type-bmp.js";
import "../../../../_virtual/file-type-csv.js";
import "../../../../_virtual/file-type-doc.js";
import "../../../../_virtual/file-type-docx.js";
import "../../../../_virtual/file-type-jpg.js";
import "../../../../_virtual/file-type-pdf.js";
import "../../../../_virtual/file-type-png.js";
import "../../../../_virtual/file-type-ppt.js";
import "../../../../_virtual/file-type-txt.js";
import "../../../../_virtual/file-type-zip.js";
import "../../../../_virtual/file-upload.js";
import "../../../../_virtual/file-zip.js";
import "../../../../_virtual/filter.js";
import "../../../../_virtual/flag.js";
import "../../../../_virtual/fold.js";
import "../../../../_virtual/fold-up.js";
import "../../../../_virtual/folder.js";
import "../../../../_virtual/folder-plus.js";
import "../../../../_virtual/folders.js";
import "../../../../_virtual/gift.js";
import "../../../../_virtual/git-branch.js";
import "../../../../_virtual/grip-horizontal.js";
import "../../../../_virtual/grip-vertical.js";
import "../../../../_virtual/hash.js";
import "../../../../_virtual/heart.js";
import "../../../../_virtual/help-circle.js";
import "../../../../_virtual/history.js";
import "../../../../_virtual/home-search.js";
import "../../../../_virtual/hourglass-empty.js";
import "../../../../_virtual/inbox.js";
import "../../../../_virtual/info-circle.js";
import "../../../../_virtual/input-ai.js";
import "../../../../_virtual/italic.js";
import "../../../../_virtual/label.js";
import "../../../../_virtual/language.js";
import "../../../../_virtual/layout-grid.js";
import "../../../../_virtual/layout-sidebar.js";
import "../../../../_virtual/link.js";
import "../../../../_virtual/list.js";
import "../../../../_virtual/list-check.js";
import "../../../../_virtual/loader-2.js";
import "../../../../_virtual/lock.js";
import "../../../../_virtual/lock-filled.js";
import "../../../../_virtual/lock-open.js";
import "../../../../_virtual/logout.js";
import "../../../../_virtual/mail.js";
import "../../../../_virtual/menu-2.js";
import "../../../../_virtual/message.js";
import "../../../../_virtual/message-2-exclamation.js";
import "../../../../_virtual/message-2-plus.js";
import "../../../../_virtual/message-check.js";
import "../../../../_virtual/message-question.js";
import "../../../../_virtual/message-user.js";
import "../../../../_virtual/minus.js";
import "../../../../_virtual/mood-confuzed.js";
import "../../../../_virtual/mood-smile.js";
import "../../../../_virtual/music.js";
import "../../../../_virtual/number-123.js";
import "../../../../_virtual/package.js";
import "../../../../_virtual/packages.js";
import "../../../../_virtual/paperclip.js";
import "../../../../_virtual/percentage.js";
import "../../../../_virtual/phone.js";
import "../../../../_virtual/photo.js";
import "../../../../_virtual/pinned.js";
import "../../../../_virtual/pinned-off.js";
import "../../../../_virtual/play.js";
import "../../../../_virtual/playlist-add.js";
import "../../../../_virtual/plus.js";
import "../../../../_virtual/presentation-analytics.js";
import "../../../../_virtual/progress.js";
import "../../../../_virtual/question-circle.js";
import "../../../../_virtual/quote.js";
import "../../../../_virtual/receipt.js";
import "../../../../_virtual/refresh.js";
import "../../../../_virtual/regex.js";
import "../../../../_virtual/reload.js";
import "../../../../_virtual/report-medical.js";
import "../../../../_virtual/report-money.js";
import "../../../../_virtual/rocket.js";
import "../../../../_virtual/rosette-discount-check.js";
import "../../../../_virtual/scissors.js";
import "../../../../_virtual/search.js";
import "../../../../_virtual/select.js";
import "../../../../_virtual/send.js";
import "../../../../_virtual/settings.js";
import "../../../../_virtual/settings-2.js";
import "../../../../_virtual/share.js";
import "../../../../_virtual/sort-ascending.js";
import "../../../../_virtual/sort-descending.js";
import "../../../../_virtual/sparkles.js";
import "../../../../_virtual/stack-2.js";
import "../../../../_virtual/stack-2-filled.js";
import "../../../../_virtual/star.js";
import "../../../../_virtual/star-filled.js";
import "../../../../_virtual/table.js";
import "../../../../_virtual/table-shortcut.js";
import "../../../../_virtual/table-spark.js";
import "../../../../_virtual/tag.js";
import "../../../../_virtual/tag-plus.js";
import "../../../../_virtual/template.js";
import "../../../../_virtual/thumb-down.js";
import "../../../../_virtual/thumb-up.js";
import "../../../../_virtual/trash.js";
import "../../../../_virtual/upload.js";
import "../../../../_virtual/user.js";
import "../../../../_virtual/user-check.js";
import "../../../../_virtual/user-circle.js";
import "../../../../_virtual/user-screen.js";
import "../../../../_virtual/user-x.js";
import "../../../../_virtual/users.js";
import "../../../../_virtual/users-group.js";
import "../../../../_virtual/video.js";
import "../../../../_virtual/world.js";
import "../../../../_virtual/x.js";
import "../../../../node_modules/.pnpm/@uppy_locales@4.5.2/node_modules/@uppy/locales/lib/en_US.js";
import { useConfigProvider } from "../../../ui/config-provider/useConfigProvider.js";
import { getLocaleMap, fileExtIconMap } from "./utils.js";
import { Uppy } from "../../../../node_modules/.pnpm/@uppy_core@4.4.5/node_modules/@uppy/core/lib/Uppy.js";
function useFileManagerCommon(files, fileInputRef, emits, options) {
  var _a;
  const { locale } = useConfigProvider(), localeTexts = getLocaleMap(locale.value, options), errorMessage = ref({
    message: "",
    show: !1
  });
  function setErrorMessage(message, duration = 3e3) {
    errorMessage.value.message = message, errorMessage.value.show = !0, setTimeout(() => {
      errorMessage.value.show = !1;
    }, duration);
  }
  __name(setErrorMessage, "setErrorMessage");
  function handleUppyOnBeforeFileAdded(file) {
    return {
      ...file,
      id: `${file.id}__${Date.now()}__${Math.random()}`
      // 修改id，让每次添加的文件都唯一
    };
  }
  __name(handleUppyOnBeforeFileAdded, "handleUppyOnBeforeFileAdded");
  const uppy = new Uppy({
    autoProceed: !0,
    locale: localeTexts.uppyLocale,
    restrictions: {
      maxFileSize: options.perSize ? options.perSize * 1024 : void 0,
      maxNumberOfFiles: options.multiple ? options.max : 1,
      allowedFileTypes: (_a = options.accept) == null ? void 0 : _a.split(","),
      maxTotalFileSize: options.totalSize ? options.totalSize * 1024 : void 0
    },
    ...options.allowDuplicate ? { onBeforeFileAdded: handleUppyOnBeforeFileAdded } : {}
  });
  uppy.on("restriction-failed", (_, error) => {
    setErrorMessage(error.message);
  }), uppy.on("upload-progress", (file) => {
    if (!files.value)
      return;
    const index = files.value.findIndex((f) => f.uid === (file == null ? void 0 : file.id));
    index !== -1 && (files.value[index].status = "uploading", files.value[index].progress = (file == null ? void 0 : file.progress.percentage) ?? 0);
  }), uppy.on("upload-error", (file, _error) => {
    if (!files.value)
      return;
    const index = files.value.findIndex((f) => f.uid === (file == null ? void 0 : file.id));
    index !== -1 && (files.value[index].status = "failed", emits("error", files.value[index])), setErrorMessage(_error.message);
  });
  function uppyUpload(file) {
    if (!files.value)
      return;
    let uid = null;
    try {
      uid = uppy.addFile({
        name: file.name,
        type: file.type,
        data: file
      });
    } catch (error) {
      return console.error(error.message);
    }
    files.value.push({
      name: file.name,
      id: null,
      status: "init",
      size: file.size,
      raw: file,
      type: file.type,
      uid
    });
  }
  __name(uppyUpload, "uppyUpload"), (files.value ?? []).forEach((file) => {
    try {
      const uid = uppy.addFile({
        name: file.name,
        type: file.type,
        isRemote: !0,
        source: "Server",
        data: {
          size: file.size ?? 0
        }
      });
      file.uid = uid, uppy.setFileState(uid, {
        progress: {
          uploadComplete: !0,
          uploadStarted: 1,
          bytesUploaded: file.size ?? 0,
          bytesTotal: file.size ?? 0
        }
      });
    } catch (error) {
      console.error(error);
    }
  });
  const isDragOver = ref(!1), dragCounter = ref(0), isDragging = ref(!1);
  function handleDragEnter(event) {
    event.preventDefault(), event.stopPropagation(), dragCounter.value++, dragCounter.value === 1 && (isDragOver.value = !0);
  }
  __name(handleDragEnter, "handleDragEnter");
  function handleDragLeave(event) {
    event.preventDefault(), event.stopPropagation(), dragCounter.value--, dragCounter.value === 0 && (isDragOver.value = !1);
  }
  __name(handleDragLeave, "handleDragLeave");
  function handleDragOver(event) {
    event.preventDefault(), event.stopPropagation();
  }
  __name(handleDragOver, "handleDragOver");
  function handleDrop(event) {
    var _a2;
    event.preventDefault(), event.stopPropagation(), isDragOver.value = !1, dragCounter.value = 0;
    const droppedFiles = (_a2 = event.dataTransfer) == null ? void 0 : _a2.files;
    droppedFiles != null && droppedFiles.length && Array.from(droppedFiles).forEach((file) => {
      uppyUpload(file);
    });
  }
  __name(handleDrop, "handleDrop");
  function handleDragStart() {
    isDragging.value = !0;
  }
  __name(handleDragStart, "handleDragStart");
  function handleDragEnd() {
    isDragging.value = !1;
  }
  __name(handleDragEnd, "handleDragEnd");
  const uploadAreaDirection = computed(() => files.value && files.value.length <= 1 ? "vertical" : "horizontal");
  function handleSelectFile() {
    var _a2;
    (_a2 = fileInputRef.value) == null || _a2.click();
  }
  __name(handleSelectFile, "handleSelectFile");
  async function handleFileChange(event) {
    const selectedFiles = event.target.files;
    selectedFiles != null && selectedFiles.length && Array.from(selectedFiles).forEach((file) => {
      uppyUpload(file);
    }), fileInputRef.value && (fileInputRef.value.value = "");
  }
  __name(handleFileChange, "handleFileChange");
  function handleDeleteFile(file) {
    files.value && (uppy.removeFile(file.uid), files.value = files.value.filter((f) => f !== file), emits("delete", file));
  }
  __name(handleDeleteFile, "handleDeleteFile");
  function handleDownloadFile(file) {
    emits("download", file);
  }
  __name(handleDownloadFile, "handleDownloadFile");
  function getFileKey(file) {
    var _a2;
    return file.id || `${file.name}-${file.size}-${(_a2 = files.value) == null ? void 0 : _a2.indexOf(file)}`;
  }
  __name(getFileKey, "getFileKey");
  function getIcon(name) {
    const ext = name.split(".").pop(), icon = fileExtIconMap.find((item) => item.ext.includes(ext ?? "unknown"));
    return icon ? icon.icon : IconFile;
  }
  return __name(getIcon, "getIcon"), {
    uppy,
    errorMessage,
    setErrorMessage,
    texts: localeTexts,
    isDragOver,
    isDragging,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleDragStart,
    handleDragEnd,
    uploadAreaDirection,
    handleSelectFile,
    handleFileChange,
    handleDeleteFile,
    handleDownloadFile,
    getFileKey,
    getIcon
  };
}
__name(useFileManagerCommon, "useFileManagerCommon");
export {
  useFileManagerCommon
};
//# sourceMappingURL=useFileManagerCommon.js.map
